var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 2.16667H7.8V13H12.5667V3.03333C12.5667 2.80348 12.4754 2.58304 12.3128 2.42051C12.1503 2.25798 11.9299 2.16667 11.7 2.16667ZM9.53333 9.53333H8.66667V8.66667H9.53333V9.53333ZM9.53333 7.36667H8.66667V6.5H9.53333V7.36667ZM9.53333 5.2H8.66667V4.33333H9.53333V5.2ZM11.2667 9.53333H10.4V8.66667H11.2667V9.53333ZM11.2667 7.36667H10.4V6.5H11.2667V7.36667ZM11.2667 5.2H10.4V4.33333H11.2667V5.2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01467 0H0.918667C0.675021 0 0.441355 0.0967878 0.269071 0.269071C0.0967878 0.441355 0 0.675021 0 0.918667V13H2.16667V11.7H4.76667V13H6.93333V0.918667C6.93333 0.675021 6.83655 0.441355 6.66426 0.269071C6.49198 0.0967878 6.25831 0 6.01467 0ZM2.16667 9.53333H1.3V8.66667H2.16667V9.53333ZM2.16667 7.36667H1.3V6.5H2.16667V7.36667ZM2.16667 5.2H1.3V4.33333H2.16667V5.2ZM2.16667 3.03333H1.3V2.16667H2.16667V3.03333ZM3.9 9.53333H3.03333V8.66667H3.9V9.53333ZM3.9 7.36667H3.03333V6.5H3.9V7.36667ZM3.9 5.2H3.03333V4.33333H3.9V5.2ZM3.9 3.03333H3.03333V2.16667H3.9V3.03333ZM5.63333 9.53333H4.76667V8.66667H5.63333V9.53333ZM5.63333 7.36667H4.76667V6.5H5.63333V7.36667ZM5.63333 5.2H4.76667V4.33333H5.63333V5.2ZM5.63333 3.03333H4.76667V2.16667H5.63333V3.03333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon-12.48658ae6f1e3a57532a12765127ac199.svg";
export { ForwardRef as ReactComponent };